import { Component, OnInit, ViewChild } from '@angular/core';
import { AvtListesComponent } from '../avt-listes/avt-listes.component';
import {GeneralService} from "../services/general.service"
@Component({
  selector: 'app-param-taux',
  templateUrl: './param-taux.component.html',
  styleUrls: ['./param-taux.component.scss']
})
export class ParamTauxComponent implements OnInit 
{
  @ViewChild("listeTauxComponen",{static : false}) listeTauxComponen : AvtListesComponent
  listBtn:Array<any> = 
  [
    {name:"enregistrer",class:"colorGreen",text:"Enregistrer",disabled : false,icon:"save"},
  ]
  Columns=
  {
    TableRD:
    [
      {TableRD_Champs:"avtTaux_NbrCh",TableRD_Des:"N° Chevaux",TableRD_Largeur:"50px","TableRD_ReadOnly":true,"TableRD_Format":"","TableRD_Alligement":0,"TableRD_Ordre":0,"TableRD_Type":0,"TableRD_Param1":null,"TableRD_Param2":"number","TableRD_ValDef":null,"TableRD_Tri":true,"TableRD_Valid":null,"TableRD_ValidType":0,"TableRD_ExpressionH":null,"TableRD_ExpressionR":null,"User_Id":"*","User_Groupe":null},    
      {TableRD_Champs:"avtTaux_Inf5",TableRD_Des:"Moins de 5000km",TableRD_Largeur:"50px","TableRD_ReadOnly":false,"TableRD_Format":"","TableRD_Alligement":0,"TableRD_Ordre":1,"TableRD_Type":0,"TableRD_Param1":null,"TableRD_Param2":"number","TableRD_ValDef":null,"TableRD_Tri":true,"TableRD_Valid":null,"TableRD_ValidType":0,"TableRD_ExpressionH":null,"TableRD_ExpressionR":null,"User_Id":"*","User_Groupe":null},
      {TableRD_Champs:"avtTaux_Sup5Inf20Cof",TableRD_Des:"5001 à 20000km",TableRD_Largeur:"50px","TableRD_ReadOnly":false,"TableRD_Format":"","TableRD_Alligement":0,"TableRD_Ordre":2,"TableRD_Type":0,"TableRD_Param1":null,"TableRD_Param2":"number","TableRD_ValDef":null,"TableRD_Tri":true,"TableRD_Valid":null,"TableRD_ValidType":0,"TableRD_ExpressionH":null,"TableRD_ExpressionR":null,"User_Id":"*","User_Groupe":null},
      {TableRD_Champs:"avtTaux_Sup5Inf20Marge",TableRD_Des:"5001 à 20000km (marge)",TableRD_Largeur:"50px","TableRD_ReadOnly":false,"TableRD_Format":"","TableRD_Alligement":0,"TableRD_Ordre":3,"TableRD_Type":0,"TableRD_Param1":null,"TableRD_Param2":"number","TableRD_ValDef":null,"TableRD_Tri":true,"TableRD_Valid":null,"TableRD_ValidType":0,"TableRD_ExpressionH":null,"TableRD_ExpressionR":null,"User_Id":"*","User_Groupe":null},
      {TableRD_Champs:"avtTaux_Sup20",TableRD_Des:"Plus de 20000km",TableRD_Largeur:"50px","TableRD_ReadOnly":false,"TableRD_Format":"","TableRD_Alligement":0,"TableRD_Ordre":4,"TableRD_Type":0,"TableRD_Param1":null,"TableRD_Param2":"number","TableRD_ValDef":null,"TableRD_Tri":true,"TableRD_Valid":null,"TableRD_ValidType":0,"TableRD_ExpressionH":null,"TableRD_ExpressionR":null,"User_Id":"*","User_Groupe":null}
    ]
  };
  
  constructor(public generalService : GeneralService) { }

  async ngOnInit() 
  {
    this.generalService.rechercheTable(this.generalService.urlListTauxKm).subscribe(data =>
    {
      this.listeTauxComponen.setDataSource(data)
    })
    
  }
  clickBtnHeat(event)
  {
    switch (event.name)
    {
      case "enregistrer":
      {
        this.enregistrer(event.row)
        break;
      }
    }
  }
  enregistrer(row)
  {
    if(row.id)
    this.generalService.rechercheTable("ds/formdata?code=avtTauxKm&val=" +row.id).subscribe(data =>
    {
      data.avtTauxKm[0].avtTaux_Inf5 = row.avtTaux_Inf5;
      data.avtTauxKm[0].avtTaux_NbrCh = row.avtTaux_NbrCh;
      data.avtTauxKm[0].avtTaux_Sup5Inf20Cof = row.avtTaux_Sup5Inf20Cof;
      data.avtTauxKm[0].avtTaux_Sup5Inf20Marge = row.avtTaux_Sup5Inf20Marge;
      data.avtTauxKm[0].avtTaux_Sup20 = row.avtTaux_Sup20;
      this.generalService.enregisterTable(data).subscribe(()=>
      {
        this.generalService.dialogSuccess("Enregistré",true)
      })

    })
    else
    this.generalService.dialogSuccess("Veillez sélectionner une ligne",false)
  }
}
